import { themeState } from '../utils/theme';

const lightPalette = ['#20b68b', '#f0a440', '#8b72db', '#e67d68', '#24a4b5', '#79b648', '#d66ba0', '#c68a48', '#5d9ac6', '#b8a52d'];
const originalPalettes = new WeakMap();

// 只更新图表的展示颜色，保留当前数据、缩放范围和图例选择。
const updateChart = (chart, capturePalette) => {
  if (!chart || chart.isDisposed()) return;
  const light = themeState.current === 'light';
  const text = light ? '#344b43' : '#87cefa';
  const strong = light ? '#182e25' : '#b0e2ff';
  const line = light ? '#e0eee7' : '#003567';
  const option = chart.getOption();
  // 业务重新绘制时记录原始配色，切回深色时恢复原来的渐变和多曲线颜色。
  if (capturePalette || !originalPalettes.has(chart)) {
    originalPalettes.set(chart, {
      color: option.color,
      series: (option.series || []).map(series => ({
        itemStyle: series.itemStyle || {},
        lineStyle: series.lineStyle || {}
      }))
    });
  }
  const original = originalPalettes.get(chart);
  const axes = axis => (axis || []).map(() => ({
    axisLabel: { color: text },
    axisLine: { lineStyle: { color: line } },
    axisTick: { lineStyle: { color: line } },
    splitLine: { lineStyle: { color: line } }
  }));
  chart.setOption({
    color: light ? lightPalette : original.color,
    backgroundColor: option.backgroundColor && option.backgroundColor !== 'transparent'
      ? (light ? '#ffffff' : '#001a33') : 'transparent',
    textStyle: { color: text },
    title: (option.title || []).map(() => ({ textStyle: { color: text }, subtextStyle: { color: strong } })),
    legend: (option.legend || []).map(() => ({ textStyle: { color: text } })),
    tooltip: {
      backgroundColor: light ? 'rgba(255, 255, 255, 0.96)' : 'rgba(0, 43, 77, 0.96)',
      borderColor: line,
      borderWidth: 1,
      textStyle: { color: strong }
    },
    xAxis: axes(option.xAxis),
    yAxis: axes(option.yAxis),
    series: (option.series || []).map((series, index) => {
      const color = lightPalette[index % lightPalette.length];
      const saved = original.series[index] || { itemStyle: {}, lineStyle: {} };
      const normal = saved.itemStyle.normal || {};
      const defaultColor = (original.color || [])[index % ((original.color || []).length || 1)];
      const itemColor = saved.itemStyle.color || normal.color || defaultColor;
      const lineColor = saved.lineStyle.color || (normal.lineStyle || {}).color || itemColor;
      return {
        label: { color: strong, normal: { color: strong } },
        itemStyle: {
          color: light ? color : itemColor,
          normal: {
            color: light ? color : itemColor,
            lineStyle: { color: light ? color : lineColor }
          }
        },
        lineStyle: { color: light ? color : lineColor }
      };
    })
  });
};

export default {
  computed: {
    solarTheme() { return themeState.current; }
  },
  watch: {
    solarTheme() { this.$nextTick(() => this.applyChartTheme(false)); }
  },
  methods: {
    applyChartTheme(capturePalette = true) {
      [this.myChart, this.chartInstance, this.usageChart].forEach(chart => updateChart(chart, capturePalette));
    }
  }
};
